import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    dialog: {
      width: 900,
      maxWidth: 400,
      borderRadius: 16,
      padding: '16px 32px 32px 32px',

      '@media (max-width: 1180px)': {
        width: 343,
      },
    },
    qrCodeContainer: {
      padding: 20,
    },
  }),
);
